import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.icon)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.iconComponent), {
        key: 0,
        class: _normalizeClass(['title-icon', { 'title-upper': _ctx.icon === 'RiDoubleQuotesL' }])
      }, null, 8, ["class"]))
    : _createCommentVNode("", true)
}